import axios from '@/utils/request'

export default {
    getBannerList: (data) => axios({ url: '/api/product/banner/list', method: 'POST', data }), // banner列表
    bannerManageAdd: (data) => axios({ url: '/api/product/banner/add', method: 'POST', data }), // 新增banner
    bannerManageEdit: (id) => axios({ url: `/api/product/banner/get/${id}`, method: 'get' }), // 编辑banner  获取信息
    bannerManageDelete: (id) => axios({ url: `/api/product/banner/delete/${id}`, method: 'delete' }), // 删除banner
    bannerManageUpdate: (data) => axios({ url: `/api/product/banner/update`, method: 'put', data }), // 修改banner
}